// extracted by mini-css-extract-plugin
export default {"errorPopUp":"ErrorPopUp_errorPopUp__mLpKV","bgArea":"ErrorPopUp_bgArea__683Oy","fadeIn":"ErrorPopUp_fadeIn__UWokN"};